import { inject, Pipe, PipeTransform } from '@angular/core';
import { I18nService } from '../../core/services/i18n.service';
import { CustomerStatus } from '../enums/organisation/customer-status';

@Pipe({
  name: 'customerStatusTag'
})
export class CustomerStatusTagPipe implements PipeTransform {

  i18n = inject(I18nService);

  transform(status: CustomerStatus, formatType: 'VALUE' | 'SEVERITY' | 'ICON'): any {

    switch (formatType) {
      case 'VALUE':
        return this.i18n.i18nLng()['C_STATUS_' + status];
      case 'SEVERITY':
        switch (status) {
          case CustomerStatus.NEW:
            return 'info';
          case CustomerStatus.CUSTOMER:
            return 'success';
          case CustomerStatus.CANCELLED:
            return 'danger';
          default:
            return 'warn';
        }
      case 'ICON':
        switch (status) {
          case CustomerStatus.NEW:
            return 'pi pi-file-plus';
          case CustomerStatus.CUSTOMER:
            return 'pi pi-user';
          case CustomerStatus.CUSTOMER_IN_PROGRESS:
            return 'pi pi-file-edit';
          default:
            return 'pi pi-exclamation-triangle';
        }
    }
  }

}
